import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ErrorTranslatorPipe } from './error-translator.pipe';
import { FormControlPipe } from './form-control.pipe';
import { LocalizedDatePipe } from './localized-date.pipe';
import { LocalizedNumberPipe } from './localized-number.pipe';
import { PhonePipe } from './phone.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { NumberPipe } from './sl-number.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [PhonePipe, SafeUrlPipe, LocalizedDatePipe, LocalizedNumberPipe, NumberPipe, FormControlPipe, ErrorTranslatorPipe],
    exports: [PhonePipe, SafeUrlPipe, LocalizedDatePipe, LocalizedNumberPipe, NumberPipe, FormControlPipe, ErrorTranslatorPipe]
})
export class PipesModule {}
